import { useMemo } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { isExchangeFlow } from "./isExchangeFlow";

/**
 * React hook that determines if the current page is part of a flight exchange flow.
 *
 * Exchange flows use the path pattern from FLIGHTS_EXCHANGE_PATH:
 * `/trips/flights/${itineraryId}/exchange/*`
 *
 * This hook memoizes the result and updates reactively when the route changes.
 * Use this in React components/hooks for proper reactivity.
 * For non-React contexts (thunks, utilities), use isExchangeFlow() instead.
 *
 * NOTE: This client-side check is safe because backend validates exchange
 * eligibility and itinerary ownership. It avoids Redux state coupling across flows.
 *
 * @returns true if currently in an exchange flow
 */
export const useIsExchangeFlow = (): boolean => {
  const location = useLocation();

  return useMemo(() => {
    return isExchangeFlow(location.pathname);
  }, [location.pathname]);
};
